import { atom } from 'jotai';

export type SpotlightTarget =
  | 'sidebar-reporting'
  | 'sidebar-reports-item'
  | 'sidebar-embedded-charts';

export interface SpotlightState {
  isActive: boolean;
  target: SpotlightTarget | null;
  content: React.ReactNode | null;
}

// Atom to manage spotlight state
export const spotlightAtom = atom<SpotlightState>({
  isActive: false,
  target: null,
  content: null,
});

// Helper function to trigger spotlight
export const triggerSpotlight = (
  target: SpotlightTarget,
  content: React.ReactNode
) => ({
  isActive: true,
  target,
  content,
});

// Helper function to close spotlight
export const closeSpotlight = (): SpotlightState => ({
  isActive: false,
  target: null,
  content: null,
});
